<template>
  <div class="verify-email-container">
    <div class="redirecting-message">
      <p>Redirecting to email verification...</p>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(() => {
  // All email verification now uses OTP flow handled in EmailVerificationForm
  // Redirect to email verification page where user can enter OTP
  router.push("/email-verification");
});
</script>

<style scoped>
.verify-email-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.redirecting-message {
  text-align: center;
  color: var(--primary-blue);
  font-size: 18px;
}
</style>
